namespace Areas.Dialogs.GLMemo {
    "use strict";

    let projectId: number;
    let baseURL: string;


    export function getEditMemoProjectID() {
        return projectId;
    }


    export function fillEditRelatedAccountFields(e) {

        var form: DevExpress.ui.dxForm = $('#EditGLMemoForm').dxForm('instance');

        var faucc: DevExpress.ui.dxTextBox = form.getEditor('FAUCostCenter') as DevExpress.ui.dxTextBox;
        var fauaccount: DevExpress.ui.dxTextBox = form.getEditor('FAUAccount') as DevExpress.ui.dxTextBox;
        var projectid: DevExpress.ui.dxTextBox = form.getEditor('ProjectId') as DevExpress.ui.dxTextBox;

        if (e.selectedItem != null) {
            faucc.option("value", e.selectedItem.accountNumber);
            fauaccount.option("value", e.selectedItem.projectNumber);
            projectid.option("value", e.selectedItem.projectId);
            projectId = e.selectedItem.projectId;  


        }

    }

    export function fillEditRelatedGLTypeFields(e) {

        var form: DevExpress.ui.dxForm = $('#EditGLMemoForm').dxForm('instance');

        var fauactivitytypelk: DevExpress.ui.dxTextBox = form.getEditor('GLActivityTypeLk') as DevExpress.ui.dxTextBox;

        if (e.selectedItem != null) {
            fauactivitytypelk.option("value", e.selectedItem.glActivityTypeLk);
        }

    }

    export function fillEditRelatedFAUSubField(e) {
        var form: DevExpress.ui.dxForm = $('#EditGLMemoForm').dxForm('instance');

        var fausub: DevExpress.ui.dxTextBox = form.getEditor('FAUSub') as DevExpress.ui.dxTextBox;
  
        if (e.selectedItem != null) {
            fausub.option("value", e.selectedItem.ucopSubCodeLk);
        }

    }

    export function fillEditRelatedFAUFundField(e) {
        var form: DevExpress.ui.dxForm = $('#EditGLMemoForm').dxForm('instance');

        var faufund: DevExpress.ui.dxTextBox = form.getEditor('FAUFund') as DevExpress.ui.dxTextBox;

        if (e.selectedItem != null) {
            faufund.option("value", e.selectedItem.fundingSourceCode);
        }

    }


    export class EditGLMemoDialog extends Areas.BaseDialog {

        constructor(closeHandler: (dialogResult: DialogResult, data: any) => void, parameters: any) {
            super("EditGLMemo", closeHandler, parameters, () => {

                const form = $("#EditGLMemoForm").dxForm("instance");
                const formData: any = form.option("formData");

                if (parameters.calledFrom === "GL") {
                    baseURL = "/Finance/Balances/PutGLMemo";
                } else {
                    baseURL = "/Finance/Memos/PutGLMemo";
                }

                projectId = parameters.data.projectId;
                formData.GLDataId = parameters.data.glDataId;
                formData.AccountId = parameters.data.accountId;
                formData.FundingSourceId = parameters.data.fundingSourceId;
                formData.GLLinearMonthId = parameters.data.glLinearMonthId;
                formData.UCOPSubCodeLk = parameters.data.ucopSubCodeLk;
                formData.GLPostingDate = parameters.data.glPostingDate;
                formData.ProjectName = parameters.data.projectName;
                formData.ProjectNumber = parameters.data.projectNumber;
                formData.ProjectId = parameters.data.projectId;
                formData.FAULocation = parameters.data.fauLocation;
                formData.FAUObject = parameters.data.fauObject;
                formData.FAUAccount = parameters.data.fauAccount;
                formData.FAUCostCenter = parameters.data.fauCostCenter;
                formData.GLTypeEntryLk = parameters.data.glTypeEntryLk;
                formData.GLActivityTypeLk = parameters.data.glActivityTypeLk;
                formData.GLAmount = parameters.data.glAmount;
                formData.GLReference = parameters.data.glReference;
                formData.GLSummary = parameters.data.glSummary;
                formData.FAUDescription = parameters.data.fauDescription;
                formData.FAUReference = parameters.data.fauReference;
                formData.FAUFund = parameters.data.fauFund;
                formData.FAUSub = parameters.data.fauSub;
                formData.IsActive = parameters.data.isActive;

                form.option("formData", formData);
            });
        }

        protected ok = (e: any) => {
            const form = $("#EditGLMemoForm").dxForm("instance");
            const result: any = form.validate();
            const formData: any = form.option("formData");
            let keyId = formData.GLDataId;

            if (result.isValid) {

                const newData: any = form.option("formData");
                if (newData.GLAmount === null) {
                    newData.GLAmount = 0;
                }

                sendRequest(`${baseURL}/${keyId}`, JSON.stringify(newData), "PUT", () => {
                    this.close(DialogResult.Ok, null);
                });

               
            }
        }
    }





}

